import { useState, RefObject } from 'react'
import useResizeObserver from '@react-hook/resize-observer'

export const useScrollCheck = (
  ref: RefObject<HTMLElement>,
  scrollType: 'vertical' | 'horizontal'
) => {
  const [hasScroll, setHasScroll] = useState(false)

  useResizeObserver(ref, () => {
    const el = ref.current
    if (!el) return

    let scrollable = false

    if (scrollType === 'vertical') {
      scrollable = el.scrollHeight > el.clientHeight
    } else {
      scrollable = el.scrollWidth > el.clientWidth
    }

    setHasScroll(scrollable)
  })

  return hasScroll
}
